<template>
  <div>
    <b-modal
      class="modal-attendance"
      id="modal-attendance"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="s"
      title="Attendance"
    >
      <div class="mb-3">
        <h5>{{ presence.name }}</h5>
        <div class="info-employee">
          <div class="justify-content-between d-flex text-muted pl-2 pr-2 mb-2">
            <div>
              Employee ID
            </div>
            <div>
              {{ presence.employeeNo }}
            </div>
          </div>
          <div class="justify-content-between d-flex text-muted pl-2 pr-2">
            <div>
              Postion
            </div>
            <div>
              {{ presence.position }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <b-form-group
          label="Attendance Type"
        >
          <custom-select
            placeholder="Select Attendance Type"
            :options="type"
            v-model="selectedTypeAttendance"
          />
        </b-form-group>
      </div>
      <div>
        <b-button variant="warning" block @click="saveAttendance">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    typeAttendance: {
      type: Array,
      default: () => []
    },
    presence: {
      type: Object,
      default: () => {}
    },
    month: {
      type: Number,
      default: () => null
    },
    dataAttendance: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        attendanceTypeId: '',
        attendanceId: '',
        attendanceDate: ''
      },
      selectedTypeAttendance: [],
      type: []
    }
  },
  methods: {
    getCurrentFormattedDate() {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const day = String(currentDate.getDate()).padStart(2, '0')

      return `${year}-${this.month}-${day}`
    },
    saveAttendance() {
      this.typeAttendance.forEach(item => {
        if (item.name === this.selectedTypeAttendance) {
          this.form.attendanceTypeId = item.id
        }
      })
      this.form.attendanceDate = this.getCurrentFormattedDate()
      this.form.attendanceId = this.presence.attendanceId
      this.$emit('save', this.form)
      this.$bvModal.hide('modal-attendance')
      this.form = {
        attendanceTypeId: '',
        attendanceId: '',
        attendanceDate: ''
      }
      this.selectedTypeAttendance = []
    }
  },
  watch: {
    typeAttendance: {
      handler() {
        this.typeAttendance.forEach(item =>
          this.type.push(item.name)
        )
      },
      immediate: true
    },
    dataAttendance: {
      handler() {
        this.selectedTypeAttendance = ''
        const typeAttendance = this.typeAttendance.find(item => item.id === this.dataAttendance.attendanceTypeId)
        if (!typeAttendance) {
          this.selectedTypeAttendance = ''
        } else {
          this.selectedTypeAttendance = typeAttendance.name
        }
      },
      deep: true
    }
  }
}
</script>
